/**
 * 파이프라인 엔티티의 annotation 키.
 *
 * 경로 규칙이 5곳에 중복됐던 근본 원인은 **엔티티가 자기 파일 위치를 모른다**는
 * 것이었다. 그래서 모든 소비자가 이름에서 역산했고, team_tag 에 언더스코어가
 * 있으면 틀렸다(DPD-13510).
 *
 * 해법은 함수 공유가 아니라 생성 시점에 한 번 기록해 **데이터로 두는 것**이다.
 * 새 규약에서는 파일이 3 개 이상으로 늘었지만 전부 `{team, folder, dag_id}` 와
 * 테이블 목록에서 결정되므로(`paths.pipelineFiles`) 그 값들만 적는다 — 파일
 * 경로를 개별로 적으면 하나만 고쳐져 어긋날 수 있다.
 */
export const ANNOTATION_TEAM_TAG = 'dp.yogiyo.io/team-tag';
/** `dags-{team}` 아래 폴더 경로. `/` 로 중첩한다. */
export const ANNOTATION_DAG_FOLDER = 'dp.yogiyo.io/dag-folder';
export const ANNOTATION_DAG_REPO = 'dp.yogiyo.io/dag-repo';
export const ANNOTATION_CATALOG_REPO = 'dp.yogiyo.io/catalog-repo';
export const ANNOTATION_CATALOG_PATH = 'dp.yogiyo.io/catalog-path';

/**
 * 렌더된 DAG 파일들의 sha256. **Backstage 밖에서 손으로 고쳤는지** 판정한다.
 *
 * 권위 설정은 catalog repo 의 `spec.pipelineConfig` 이고 DAG 파일은 그것의
 * 파생물이다. 그런데 가이드는 사람이 직접 파일을 고치는 것도 정상 경로로
 * 두므로, 손 수정이 있으면 폼 상태가 낡는다. 그 상태로 저장하면 사람의 수정이
 * **조용히 되돌아간다** — D3 와 같은 결함군이다. 다이제스트가 어긋나면 저장
 * 전에 경고한다.
 */
export const ANNOTATION_RENDERED_DIGEST = 'dp.yogiyo.io/rendered-digest';

/** Airflow DAG id. 엔티티 이름과 같은 값이다. */
export const ANNOTATION_DAG_ID = 'airflow.apache.org/dag-id';
